import React, { useState, useEffect } from 'react';
import { Box, Typography, Modal, TextField, Button, Grid, MenuItem, FormControl, InputLabel, Select, CircularProgress, Snackbar, Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { RoomService } from '../api/services/roomService';

export default function WingFormModal({ open, onClose, wing = null, onRefresh }) {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        status: 'Active'
    });
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

    useEffect(() => {
        if (wing) {
            setFormData({
                name: wing.name || '',
                status: wing.status || 'Active'
            });
        } else {
            setFormData({
                name: '',
                status: 'Active'
            });
        }
    }, [wing, open]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const authData = JSON.parse(localStorage.getItem('adminAuth') || '{}');
            const tenantId = authData.tenantId || '1';

            const payload = {
                ...formData,
                id: wing?.id
            };

            await RoomService.saveWing(payload, tenantId);
            
            setNotification({ 
                open: true, 
                message: `Wing ${wing ? 'updated' : 'created'} successfully!`, 
                severity: 'success' 
            });
            
            if (onRefresh) onRefresh();
            setTimeout(onClose, 1000);
        } catch (error) {
            console.error('Failed to save wing:', error);
            setNotification({ 
                open: true, 
                message: error.message || 'Failed to save wing', 
                severity: 'error' 
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <Box sx={{
                    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: 400 }, bgcolor: 'background.paper', borderRadius: 3, p: 4, boxShadow: 24
                }}>
                    <IconButton sx={{ position: 'absolute', top: 12, right: 12 }} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>

                    <Typography variant="h6" fontWeight="bold" mb={3}>
                        {wing ? 'Edit Wing' : 'Create New Wing'}
                    </Typography>

                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    required
                                    label="Wing Name"
                                    name="name"
                                    placeholder="e.g. North Wing"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        name="status"
                                        value={formData.status}
                                        label="Status"
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="Active">Active</MenuItem>
                                        <MenuItem value="Inactive">Inactive</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Box sx={{ display: 'flex', gap: 2, mt: 4 }}>
                            <Button fullWidth variant="outlined" onClick={onClose} disabled={loading}>Cancel</Button>
                            <Button 
                                fullWidth 
                                type="submit"
                                variant="contained" 
                                disabled={loading}
                                startIcon={loading && <CircularProgress size={20} color="inherit" />}
                            >
                                {loading ? 'Saving...' : wing ? 'Update Wing' : 'Create Wing'}
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Modal>

            <Snackbar
                open={notification.open}
                autoHideDuration={4000}
                onClose={() => setNotification({ ...notification, open: false })}
            >
                <Alert severity={notification.severity} sx={{ width: '100%' }}>
                    {notification.message}
                </Alert>
            </Snackbar>
        </>
    );
}
